import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, Table, Td, StatCard, money, fmt } from "../../components/dashboard/Shared";
import { MonthlyBars } from "../../components/dashboard/Charts";

export default function Performance() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/manager/performance").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <div className="space-y-5"><div className="skeleton h-24" /><div className="skeleton h-64" /><div className="skeleton h-80" /></div>;

  return (
    <div>
      <PageHeader title="Performance" sub="Cross-client analytics and drawdown intelligence" />
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <StatCard testId="perf-win-rate" label="Avg Win Rate" value={`${fmt(data.avg_win_rate, 1)}%`} accent="text-[#00E676]" />
        <StatCard testId="perf-max-dd" label="Worst Drawdown" value={`${fmt(data.max_drawdown)}%`} accent="text-[#FFD600]" />
        <StatCard testId="perf-clients" label="Tracked Accounts" value={data.clients.length} />
      </div>
      <div className="card-dark p-5 mb-6">
        <p className="label-xs mb-4">Monthly Aggregate Profit ($)</p>
        <MonthlyBars data={data.monthly_profit} dataKey="profit" unit="$" height={260} />
      </div>
      <p className="label-xs mb-4">Client Performance</p>
      <Table headers={["Client", "Account", "Equity", "Total Profit", "Win Rate", "Trades", "Max DD"]} testId="client-performance-table">
        {data.clients.map((c) => (
          <tr key={c.account_id} className="border-b border-white/5 hover:bg-white/[0.02]">
            <Td><p className="text-white">{c.client}</p><p className="text-xs text-gray-500">{c.email}</p></Td>
            <Td className="tabular text-xs">{c.broker} · {c.login}</Td>
            <Td className="tabular">{money(c.equity)}</Td>
            <Td className={`tabular ${c.profit >= 0 ? "text-[#00E676]" : "text-[#FF3B30]"}`}>{money(c.profit)}</Td>
            <Td className="tabular">{c.win_rate}%</Td>
            <Td className="tabular">{c.trades}</Td>
            <Td className="tabular text-[#FFD600]">{c.max_drawdown}%</Td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
